<script setup lang="ts">
useSeoMeta({
  title: 'Cantook Access - Pricing',
  ogTitle: 'Cantook Access - Pricing',
  description: 'Pay only when exporting your accessible EPUB',
  ogDescription: 'Pay only when exporting your accessible EPUB',
});

const lang = useLocalStorage('CONTENT_LANG', 'en');

const { data: dataQueried } = await useAsyncData('pages-pricing-data', () =>
  queryCollection('pricing').all(),
);
const data = computed(
  () =>
    dataQueried.value?.find(
      (item) => item.title.toLowerCase() === lang.value?.toLowerCase(),
    )?.body,
);
</script>

<template>
  <div v-if="data">
    <PricingHero
      :hero="data.hero"
      :themeKeys="{
        bg: 'var(--color-slate-950)',
        text: 'var(--ui-text-inverted)',
      }"
    />
    <PricingOptions
      :cta="data.prices.priceCta"
      :customPrice="data.prices.customPrice"
      :priceDescription="data.prices.priceDescription"
      :quantityDescription="data.prices.quantityDescription"
      :themeKeys="{
        bg: 'var(--color-white)',
        title: 'var(--ui-text)',
        description: 'var(--ui-text-toned)',
        price: 'var(--ui-text-toned)',
        ctaBg: 'var(--color-cantook-blue-500)',
        ctaFg: 'var(--color-white)',
      }"
    />
    <PricingStats
      :stats="data.why"
      :themeKeys="{
        title: 'var(--ui-text-inverted)',
        subtitle: 'var(--ui-text-inverted)',
        bg: 'var(--color-cantook-blue-600)',
        stats: 'var(--ui-text-inverted)',
        description: 'var(--ui-text-inverted)',
        afterText: 'var(--ui-text-inverted)',
        smallPrint: 'var(--ui-text-inverted)',
      }"
    />
  </div>
</template>
